import { HttpHeaders } from '@angular/common/http';
import { List, Map } from 'immutable';
import { Highlight } from '../search-data/sub-models/highlight.model';

export enum SortByEnum {
  billing_name = 'billing_name',
  category = 'category',
  client_name = 'client_name',
  code = 'code',
  created_date = 'created_date',
  date = 'date',
  date_paid = 'date_paid',
  description = 'description',
  doc_date = 'doc_date',
  doc_number = 'doc_number',
  due_date = 'due_date',
  total_owed = 'total_owed',
  start_date = 'start_date',
}

export enum SortOrderEnum {
  asc = 'asc',
  desc = 'desc',
}

export enum SearchParamsEnum {
  client_id = 'client_id',
  currency_code = 'currency_code',
  document_tax_year = 'document_tax_year',
  entity_type = 'entity_type',
  highlights = 'highlights',
  list_category = 'list_category',
  month = 'month',
  next_page_url = 'next_page_url',
  page = 'page',
  page_size = 'page_size',
  query = 'query',
  sort_by = 'sort_by',
  sort_order = 'sort_order',
  tax_year = 'tax_year',
  unit_type = 'unit_type',
  year = 'year',
}

export interface ISearchParams {
  client_id?: string;
  currency_code?: string;
  entity_type?: string;
  highlights?: boolean;
  list_category?: string;
  month?: number;
  next_page_url?: string;
  page?: number;
  page_size?: number;
  query?: string;
  sort_by?: SortByEnum;
  sort_order?: SortOrderEnum;
  year?: number;
  tax_year?: number;
}

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.date,
  sort_order: SortOrderEnum.desc,
});

export interface IEntityFilters {
  equals(other: any): boolean;
}

export interface IEntity {
  KEYS: any;
  id: string;
  localId: string;
  revisionId: string;

  isDirty(): boolean;

  equals(b: any): boolean;

  isNew(): boolean;

  mergeContent(value: Map<string, any>);

  decorateWithKeys(entity: Map<string, any>);

  setFieldInContent(keys: string | string[], value: any);
}

export interface IError {
  error: Error;
  data: any[];
}

export interface ITopLevelKeys {
  getKey: string;
  postKey: string;
  putKey: string;
  deletedKey: string;
  deleteSingleKey: string;
  getSingleKey: string;
  searchResultsKey: string;
  globalSearchResultsKey: string;
}

export interface IEntityData {
  headers: HttpHeaders;
  entities: List<any>[];
  searchParams?: ISearchParams;
  highlights?: List<Highlight>;
}

export interface IFetchFilterKey {
  [filter: string]: string;
}

export const FILTER_ACCEPT_VERSION = '1.0.0';
export const INPUT_ACCEPT_VERSION = '2.0.0';
export const INPUT_SEARCH_ACCEPT_VERSION = '2.1.0';
export const NEXT_PAGE_HEADER = 'x-pagination-next-page';
export const TAX_YEAR_FILTER_CANVAS_KEY = 'tax_year_filter_canvas_shown';
export const ALL_LIST_FILTER = 'all';
export const SEARCH_LIST_FILTER = 'search';
export const REFRESH_FILTER_DELAY = 4000;
export const NEW_ENTITY_ROUTE = 'new';
export const EDIT_ENTITY_ROUTE = 'edit';
export const SEARCH_ENTITY_ROUTE = 'search';
export const BULK_SELECT_LIMIT = 10;
